<template>
  <el-menu
    :default-active="active"
    class="el-menu-demo"
    mode="horizontal"
    @select="handleSelect"
  >
    <el-menu-item v-for="item in navList" :key="item.id" :index="item.id">
      <img
        style="object-fit: contain;"
        :src="active === item.id ? item.activeImg : item.defaultImg"
      />
      <p>{{ item.name }}</p>
    </el-menu-item>
  </el-menu>
</template>

<script>
export default {
  name: "",
  props: {
    active: {
      type: String,
      default: "1"
    }
  },
  data() {
    return {
      navList: [
        {
          id: "1",
          name: "巡检任务",
          urlName: "InspectionTask",
          defaultImg:
            "https://kc-res.izsw.net/apps/qrobot-inspection-system/inspTaskIcon.png",
          activeImg:
            "https://kc-res.izsw.net/apps/qrobot-inspection-system/inspTaskIconActive.png"
        },
        {
          id: "2",
          name: "巡检记录",
          urlName: "InspectionRecord",
          defaultImg:
            "https://kc-res.izsw.net/apps/qrobot-inspection-system/inspRecIcon.png",
          activeImg:
            "https://kc-res.izsw.net/apps/qrobot-inspection-system/inspRecIconActive.png"
        },
        {
          id: "3",
          name: "实时巡检",
          urlName: "RealTimeInspection",
          defaultImg:
            "https://kc-res.izsw.net/apps/qrobot-inspection-system/realtimeInspIcon.png",
          activeImg:
            "https://kc-res.izsw.net/apps/qrobot-inspection-system/realtimeInspIconActive.png"
        }
      ]
    };
  },
  methods: {
    handleSelect(key, keyPath) {
      if (this.active !== key) {
        let routeName = this.navList.filter(item => item.id === key)[0].urlName;
        this.$router.push({
          name: routeName
        });
      }
    }
  }
};
</script>
<style scoped lang="scss">
.el-menu {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  border: none;
  background: none;
  padding: 0 64px;
  display: flex;
  justify-content: center;
  /deep/ .el-menu-item {
    height: auto;
    border: none;
    padding: 0 38px 8px;
    color: #ffffff;
    font-size: $text-middleTitle;
    line-height: $text-middleTitle;
    img {
      width: 100px;
      height: 100px;
    }
    p {
      text-align: center;
    }
    &:hover,
    &:focus {
      background: none;
      color: #ffffff;
    }
    &.is-active {
      color: #ffd93d;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/footNav.vue